import { React, useState } from 'react'
import { motion } from "framer-motion";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faChevronRight, faCircleInfo, faUserPlus } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import AdminGuard from '../../../components/AdminGuard/AdminGuard.js'

import { lP, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, validateOrganizationUpdate, validateObjectId } from '../../../main.js'

import '../../../main.css'
import './AdminOrganizationCreate.css'
import './MAdminOrganizationCreate.css'

import Cookies from 'universal-cookie'

export default function AdminOrganizationCreate() {

    var [banner, setBanner] = useState(null)
    var [saving, setSaving] = useState(false)

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    var [formData, setFormData] = useState({
        formName: "",
        formDescription: "",
        formMail: "",
        formTel: "",
        formUrl: "",
        formImprintUrl: "",
        formManagerId: "",
    })

    function setField(key, value) {
        setFormData({ ...formData, [key]: value })
    }

    function doCreate() {
        if (saving) return
        setBanner(null)

        var check = validateOrganizationUpdate({
            name: formData.formName,
            description: formData.formDescription,
            email: formData.formMail,
            tel: formData.formTel,
            url: formData.formUrl,
            imprint_url: formData.formImprintUrl,
        })
        if (check.error != null) {
            setBanner({ type: "error", text: "Bitte überprüfe deine Eingaben. Alle Pflichtfelder müssen korrekt ausgefüllt sein." })
            return
        }
        if (formData.formManagerId !== "" && validateObjectId(formData.formManagerId).error != null) {
            setBanner({ type: "error", text: "Die User-ID des ersten Managers ist ungültig (24 Zeichen)." })
            return
        }

        setSaving(true)
        setBanner({ type: "loading", text: "Organisation wird angelegt..." })

        var reqbody = {
            "name": formData.formName,
            "description": formData.formDescription,
            "contact": {
                "email": formData.formMail,
                "tel": formData.formTel,
                "url": formData.formUrl,
                "imprint_url": formData.formImprintUrl,
            },
        }
        if (formData.formManagerId !== "") reqbody.managerid = formData.formManagerId

        try {
            fetch(URL_MAINAPI + "/organization/create", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status === 200 && res.data._id) {
                    setBanner({ type: "done", text: "Organisation wurde angelegt. Du wirst weitergeleitet..." })
                    lP('/manage/org/' + res.data._id)
                } else {
                    setSaving(false)
                    setBanner({ type: "error", text: "Fehler beim Anlegen: " + (res.data.error || "unbekannter Fehler") })
                }
            }))
        } catch (err) {
            setSaving(false)
            setBanner({ type: "error", text: "Es gab einen Fehler bei der Verarbeitung: " + err })
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Organisation erstellen</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <a href='/admin'>Helferzeit-Administration</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>Organisation erstellen</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    Organisation erstellen
                </motion.h1>
                <p className='section-sub'>Lege eine neue Organisation an. Weitere Manager kannst du danach unter „Organisation bearbeiten“ hinzufügen.</p>

                <AdminGuard>
                    <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                        <div className='card adminorg-card'>
                            <div className='adminorg-headline'>
                                <span className='adminorg-icon'><FontAwesomeIcon icon={faBuilding} /></span>
                                <h3>Stammdaten</h3>
                            </div>

                            <form onSubmit={(e) => { e.preventDefault(); doCreate() }}>
                                <div className='adminorg-grid'>
                                    <div className="field adminorg-full">
                                        <label htmlFor="ao-name">Name</label>
                                        <input id="ao-name" type="text" maxLength="80" minLength="2" name="name" placeholder="Organisationsname" value={formData.formName} onInput={(e) => setField('formName', e.target.value)}></input>
                                    </div>
                                    <div className="field adminorg-full">
                                        <label htmlFor="ao-desc">Beschreibung</label>
                                        <textarea id="ao-desc" name="description" rows="3" maxLength="1000" placeholder="Kurzbeschreibung (optional)" value={formData.formDescription} onInput={(e) => setField('formDescription', e.target.value)}></textarea>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="ao-mail">E-Mail</label>
                                        <input id="ao-mail" type="email" name="email" placeholder="kontakt@organisation.de" value={formData.formMail} onInput={(e) => setField('formMail', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="ao-tel">Telefon</label>
                                        <input id="ao-tel" type="tel" name="tel" placeholder="Telefonnummer" value={formData.formTel} onInput={(e) => setField('formTel', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="ao-url">Website</label>
                                        <input id="ao-url" type="url" name="url" placeholder="https://… (optional)" value={formData.formUrl} onInput={(e) => setField('formUrl', e.target.value)}></input>
                                    </div>
                                    <div className="field">
                                        <label htmlFor="ao-imprint">Impressum-URL</label>
                                        <input id="ao-imprint" type="url" name="imprint" placeholder="https://…/impressum" value={formData.formImprintUrl} onInput={(e) => setField('formImprintUrl', e.target.value)}></input>
                                    </div>
                                    <div className="field adminorg-full">
                                        <label htmlFor="ao-manager"><FontAwesomeIcon icon={faUserPlus} /> Erster Manager (User-ID, optional)</label>
                                        <input id="ao-manager" type="text" name="managerid" placeholder="z. B. 507f1f77bcf86cd799439011" value={formData.formManagerId} onInput={(e) => setField('formManagerId', e.target.value.trim())} autoComplete='off' spellCheck={false}></input>
                                        <span className='hint'>Die User-ID steht im Profil der Person unter „Profil bearbeiten“. Ohne Manager kann zunächst nur das Helferzeit-Team die Organisation verwalten.</span>
                                    </div>
                                </div>

                                {banner ? (
                                    <div className={'adminorg-banner status-banner status-banner--' + (banner.type === 'error' ? 'error' : banner.type === 'done' ? 'success' : 'info')} role={banner.type === 'error' ? 'alert' : 'status'}>
                                        <FontAwesomeIcon icon={faCircleInfo} /> {banner.text}
                                    </div>
                                ) : null}

                                <div className='adminorg-actions'>
                                    <CTAButton variant="primary" hideArrow={false} title={"Organisation anlegen"} onclick={() => doCreate()} />
                                    <CTAButton variant="secondary" hideArrow={true} title={"Abbrechen"} onclick={() => lP('/admin')} />
                                </div>
                            </form>
                        </div>
                    </motion.div>
                </AdminGuard>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
